import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerValidation } from './PlannerValidation';
/**
 * Validation for frames that have more than one stacking guest connector (to stack wider frames on multiple smaller)
 * to only stack if all connectors are available.
 * This validation rule can be replaced with pairwise reqired connectors when/if this feature gets implemented by Core
 * https://i-p-e-x.atlassian.net/browse/CORE-3354
 */
export class StackedFrameValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'StackedFrameValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            return this.validationOK();
        }
        const stackingGuestConnectors = entity
            .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
            ?.connectors.filter(connector => connector.tags().includes('stacking-guest')) || [];
        if (snapActionCandidate.guestConnector.tags().includes('stacking-guest') &&
            stackingGuestConnectors.length > 1) {
            // Frame has multiple stacking guest connectors so we need to validate them all
            const otherStackingGuestConnectorsForFrame = stackingGuestConnectors.filter(connector => connector.key !== snapActionCandidate.guestConnector.key);
            const framesInScene = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
            const fullfilledGuestConnectors = otherStackingGuestConnectorsForFrame.map(guestConnector => {
                const frameWithAlignedHostConnector = framesInScene.find(frame => {
                    const stackingHostConnectors = frame
                        .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
                        ?.connectors.filter(connector => connector.tags().includes('stacking-host')) || [];
                    return stackingHostConnectors.some(connector => this.coreApi.entities.isEntityConnectorsAligned(entity, guestConnector.key, frame, connector.key));
                });
                return frameWithAlignedHostConnector !== undefined;
            });
            return fullfilledGuestConnectors.every(fullfilled => fullfilled === true)
                ? this.validationOK()
                : this.validationFail('Cant stack partially on other frames');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=StackedFrameValidation.js.map